// @comfy/shared — 提交门控决策（纯函数，可测）
// 依据 design.md / Req 6.4：仅当实例处于 running 时才允许提交，
// 其他状态一律拒绝并提示「请先启动实例」，且不入队。
/** 非 running 状态下的统一提示文案（Req 6.4）。 */
const NOT_RUNNING_MESSAGE = "请先启动实例";
/**
 * 提交门控纯函数：根据当前电源状态决定能否提交生成请求。
 *
 * - `running`    → 允许提交（`allowed: true`）。
 * - 其他任何状态 → 拒绝提交（`allowed: false`），返回提示「请先启动实例」，
 *   调用方据此不入队。
 *
 * @param state 当前 {@link PowerState}。
 * @returns {@link SubmitDecision} 决策结果。
 */
export function canSubmit(state) {
    if (state === "running") {
        return { allowed: true };
    }
    return { allowed: false, message: NOT_RUNNING_MESSAGE };
}
//# sourceMappingURL=submitGate.js.map